import * as Highcharts from 'highcharts';
import i18next from 'i18next';

export const getConstructDateTimeLabel = (
    dayStr: string,
    monthStr: string,
    yearStr: string,
    value
) => {
    let quarter;
    let monthLocalized;

    const day = Highcharts.dateFormat(dayStr, value);
    const year = Highcharts.dateFormat(yearStr, value);

    if (monthStr === '%Q') {
        quarter = Highcharts.dateFormat(monthStr, value);
    } else {
        const month = Highcharts.dateFormat(monthStr, value).toLowerCase();
        monthLocalized = i18next.t(`date-context:months.short-name.${month}`);
    }

    return `${quarter ? quarter : day + ' ' + monthLocalized} ${year}`;
};
